module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/pets//emo-bg.png?v=a995527e";